import { LeadResponse, GetLeadError } from '@menesko/models-digesti';
import { useQuery, UseQueryOptions } from 'react-query';

import { FunnelApiClient } from '~/api';

import { useAnalytics } from '../useAnalytics';
import { useAppLead } from '../useAppLead';
import { useAppRouter } from '../useAppRouter';

export const useLeadQuery = (
  leadId?: string,
  options?: Omit<UseQueryOptions<LeadResponse, GetLeadError, LeadResponse>, 'queryKey' | 'enabled'>,
) => {
  const { updateUser } = useAppLead();
  const { query, asPath, replace } = useAppRouter();
  const analytics = useAnalytics();

  return useQuery<LeadResponse, GetLeadError, LeadResponse>(['lead', leadId], {
    queryFn: () => {
      return FunnelApiClient<unknown, LeadResponse>({
        method: 'GET',
        url: `/lead/${leadId}`,
      });
    },
    enabled: Boolean(leadId),
    onSuccess: (data) => {
      updateUser({
        id: data.id,
        quizAnswers: data.quizAnswers,
        email: data.email,
      });

      analytics.setUserProperties({ id: data.id });

      const newQuery = { ...query };

      delete newQuery.leadCode;
      delete newQuery.catchall;

      replace({ pathname: asPath.split('?')[0], query: newQuery }, undefined, { shallow: true });

      if (options?.onSuccess) {
        options.onSuccess(data);
      }
    },
    ...options,
  });
};
